<template>
	<div class="page-style-a">
		<div class="container" ref="demo">
			<div class="page-intro">
				<h2>Order Details</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<router-link :to="{name : 'Home'}">Home</router-link>
					</li>
					<li class="is-marked">
						<a href="Order Details-v2-sub-category.html">Order Details</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div class="container mt-4">
		<Spinner text="Fetching Order Details" style="height: 100px" v-if="loading" />
		<div class="card shadow p-3" v-if="!loading && orderDetails.length != 0">
			<div class="card-header bg-white" style="border-bottom: 0px">
				<div class="row justify-content-between">
					<div class="col">
						<p class="text-muted">
							Order
							<span class="font-weight-bold text-dark">#{{ orderDetails.id }}</span>
						</p>
						<p class="text-muted">
							Place On <b>{{ formatDate }}</b>
						</p>
						<p class="text-muted">
							Warehouse <b>{{ orderDetails.warehouse.name }}</b>
						</p>
						<p class="text-muted">
							Time Slot <b>{{ orderDetails.slot }}</b>
						</p>
					</div>
					<div class="flex-col my-auto">
						<button
							class="button button-primary d-block w-100 mt-2 rounded"
							data-toggle="modal"
							data-target="#tracking_modal"
						>
							Track Order
						</button>
					</div>
				</div>
			</div>
		</div>
		<div
			class="order_details_card mt-3"
			v-if="!loading && orderDetails.length != 0"
		>
			<div class="card shadow p-4">
				<div class="card-body">
					<div v-for="orderDetail in orderDetails.order_details" :key="orderDetail.id">
						<div class="media flex-column flex-sm-row">
							<div class="media-body">
								<h5 class="bold">
									{{ orderDetail.product_combination?.product.product_name }}
								</h5>
								<p class="text-muted">Qt: {{ orderDetail.qty }}</p>
								<h4 class="mt-3 mb-4 bold">
									<span class="mt-5"></span
									>{{
										formatCurrency(
											orderDetail.total_price + orderDetail.service_fee - orderDetail.tax
										)
									}}
									<span class="small text-muted"> via ({{ orderDetails.payment_method }}) </span>
								</h4>
								<div
									style="display: flex; flex-direction: column"
									v-for="av in orderDetail.product_combination?.attribute_variations"
									:key="av.id"
								>
									<span class="small text-muted"
										><b>{{ av.attribute.name }} - {{ av.variation.name }}</b></span
									>
								</div>
								<button
									type="button"
									@click="() => postReview(orderDetail)"
									class="button button-outline-secondary mt-2 mb-3"
								>
									Post Review
								</button>
								<p>Current Status : {{ orderDetails.order_status }}</p>
							</div>
						</div>
						<hr />
					</div>
					<div class="row px-3">
						<div class="col">
							<ul id="progressbar">
								<li class="step0 active" id="step1">PLACED</li>
								<li
									class="step0 text-center"
									id="step2"
									:class="{active: getOrderStatus || isOrderDelivered}"
								>
									{{ getOrderStatus || "Dispatched" }}
								</li>
								<li
									class="step0 text-muted text-right"
									:class="{active: isOrderDelivered}"
									id="step3"
								>
									DELIVERED
								</li>
							</ul>
						</div>
					</div>
					<hr />
					<div class="row">
						<div class="col-lg-6" v-if="filterOrderNotes.length > 0">
							<div class="calculation u-s-m-b-60 mt-1">
								<span style="font-size: 14px; color: black" class="bold">Order Notes</span>
								<hr />
								<div class="table-wrapper-2 notes_box">
									<div class="media" v-for="note in filterOrderNotes" :key="note.id">
										<div class="media-body">
											<div class="bg-dark rounded py-2 px-3 mb-2">
												<p class="text-small mb-0 text-white">
													{{ note.note }}
												</p>
											</div>
											<p class="small text-muted">
												{{ formatNoteDate(note.created_at) }} | {{ note.user.name }}
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							:class="{
								'col-lg-6': filterOrderNotes.length > 0,
								'col-lg-12': filterOrderNotes.length == 0,
							}"
						>
							<div class="calculation u-s-m-b-60">
								<div class="table-wrapper-2">
									<table>
										<thead>
											<tr>
												<th colspan="2">Cart Totals</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>
													<h3 class="calc-h3 u-s-m-b-0" id="tax-heading">Subtotal</h3>
													<span> (including tax)</span>
												</td>
												<td>
													<span class="calc-text">{{ formatCurrency(subtotal) }}</span>
												</td>
											</tr>
											<tr v-if="orderDetails.warehouse.state_id == orderDetails.state_id">
												<td>
													<h3 class="calc-h3 u-s-m-b-0" id="tax-heading">Tax</h3>
												</td>
												<td>
													<div class="calc-text">{{ formatCurrency(Tax / 2) }} <small>CGST</small></div>
													<div class="calc-text">{{ formatCurrency(Tax / 2) }} <small>SGST</small></div>
												</td>
											</tr>
											<tr v-else>
												<td>
													<h3 class="calc-h3 u-s-m-b-0" id="tax-heading">Tax</h3>
												</td>
												<td>
													<span class="calc-text">{{ formatCurrency(Tax) }}</span>
												</td>
											</tr>
											<tr>
												<td>
													<h3 class="calc-h3 u-s-m-b-0" id="tax-heading">Shipping Cost</h3>
												</td>
												<td>
													<span class="calc-text">{{ formatCurrency(ShippingCost) }}</span>
												</td>
											</tr>
											<tr>
												<td>
													<h3 class="calc-h3 u-s-m-b-0">Total</h3>
												</td>
												<td>
													<span class="calc-text">{{ formatCurrency(total) }}</span>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="product-not-found" v-if="!loading && orderDetails.length == 0">
		<div class="not-found">
			<h2>SORRY!</h2>
			<h6>Order Details Not Found.</h6>
		</div>
	</div>
	<TrackOrder
		modal_id="tracking_modal"
		:order_id="orderDetails.id"
		v-if="!loading && orderDetails.length != 0"
	/>
	<Footer />
</template>

<script>
	import axios from "axios";
	import Footer from "../components/Bottom/Footer.vue";
	import Spinner from "../components/Loaders/Spinner.vue";
	import moment from "moment";
	import {formatCurrency} from "../utils/common_functions";
	import TrackOrder from "../components/Modals/TrackOrder.vue";
	export default {
		components: {Footer, Spinner, TrackOrder},
		computed: {
			formatDate() {
				return moment(this.orderDetails.created_at).format("MMMM Do YYYY, h:mm:ss a");
			},
			Tax() {
				let tax = this.orderDetails.order_details.reduce(
					(acc, current) => acc + current.tax,
					0
				);
				return tax + this.orderDetails.shipping_tax;
			},
			Servicefee() {
				return this.orderDetails.order_details.reduce(
					(acc, current) => acc + current.service_fee,
					0
				);
			},
			ShippingCost() {
				return this.orderDetails.shipping_cost;
			},
			subtotal() {
				let subtotal = this.orderDetails.order_details.reduce(
					(acc, current) =>
						acc + (current.total_price + current.service_fee - current.tax),
					0
				);
				return subtotal;
			},
			total() {
				let total = this.subtotal + this.ShippingCost + this.Tax; //adding service fee in total
				return total;
			},
			getOrderStatus() {
				// getting order status
				let status = "";
				switch (this.orderDetails.order_status.toLowerCase()) {
					case "dispatched":
						status = "Dispatched";
						break;
					case "cancel":
						status = "Cancelled";
						break;
					case "return":
						status = "Return";
						break;
					default:
						status = null;
						break;
				}
				return status;
			},
			isOrderDelivered() {
				// if order status is delivered or return
				return this.orderDetails.order_status == "delivered";
			},

			filterOrderNotes() {
				let filterNotes = this.orderDetails.order_notes.filter(
					(notes) => notes.type != "private"
				);
				return filterNotes;
			},
		},
		data() {
			return {
				orderDetails: [],
				order_id: null,
				loading: true,
			};
		},
		methods: {
			formatCurrency,
			scroll() {
				const el = document.getElementsByClassName("container")[0];
				this.$smoothScroll({
					scrollTo: el, // scrollTo is also allowed to be number
					offset: 300,
				});
			},
			formatNoteDate(date) {
				return moment(date).format("MMMM Do YYYY, h:mm:ss a");
			},
			async fetchOrderDetails() {
				let token = localStorage.getItem("token");
				let url = process.env.VUE_APP_API_URL + "/api/frontend/order-detail";
				try {
					let {data} = await axios.post(
						url,
						{order_id: this.order_id},
						{
							headers: {
								Authorization: `Bearer ${token}`,
							},
						}
					);
					console.log(data.payload);
					this.orderDetails = data.payload;
					this.loading = false;
				} catch (error) {
					console.log(error);
					this.loading = false;
				}
			},
			getTotal() {
				return this.Subtotal + this.Tax;
			},
			postReview(orderDetails) {
				this.$router.push({
					name: "AddReview",
					params: {orderDetails: JSON.stringify(orderDetails)},
				});
			},
			handleInvoice(orderDetails) {
				this.$router.push({
					name: "Invoice",
					params: {orderDetails: JSON.stringify(orderDetails)},
				});
			},
		},
		mounted() {
			if (this.$route.params.id) {
				this.order_id = this.$route.params.id;
			}
			this.fetchOrderDetails();
			this.scroll();
		},
	};
</script>

<style scoped>
	.notes_box {
		height: 200px;
	}
	::-webkit-scrollbar {
		width: 3px;
	}

	::-webkit-scrollbar-thumb {
		width: 2em;
		background-color: slategray;
		border-radius: 1rem;
	}

	.text-small {
		font-size: 0.9rem;
	}

	.messages-box,
	.chat-box {
		height: 300px;
		overflow-y: scroll;
	}

	.rounded-lg {
		border-radius: 0.5rem;
	}

	input::placeholder {
		font-size: 0.9rem;
		color: #999;
	}
	.cursor-pointer {
		cursor: pointer;
	}

	.bold {
		font-weight: 600;
	}

	.small {
		font-size: 12px !important;
		letter-spacing: 0.5px !important;
	}

	.Today {
		color: rgb(83, 83, 83);
	}

	#progressbar {
		margin-bottom: 30px;
		overflow: hidden;
		color: #455a64;
		padding-left: 0px;
		margin-top: 30px;
	}

	#progressbar li {
		list-style-type: none;
		font-size: 13px;
		width: 33.33%;
		float: left;
		position: relative;
		font-weight: 400;
		color: #455a64 !important;
	}
	#progressbar #step1:before {
		content: "1";
		color: white;
		width: 29px;
		margin-left: 15px !important;
		padding-left: 11px !important;
	}

	#progressbar #step2:before {
		content: "2";
		color: #fff;
		width: 29px;
	}

	#progressbar #step3:before {
		content: "3";
		color: #fff;
		width: 29px;
		margin-right: 15px !important;
		padding-right: 11px !important;
	}

	#progressbar li:before {
		line-height: 29px;
		display: block;
		font-size: 12px;
		background: #909393;
		border-radius: 50%;
		margin: auto;
	}

	#progressbar li:after {
		content: "";
		width: 121%;
		height: 2px;
		background: #343a40;
		position: absolute;
		left: 0%;
		right: 0%;
		top: 15px;
		z-index: -1;
	}

	#progressbar li:nth-child(2):after {
		left: 50%;
	}

	#progressbar li:nth-child(1):after {
		left: 25%;
		width: 121%;
	}

	#progressbar li:nth-child(3):after {
		left: 25% !important;
		width: 50% !important;
	}

	#progressbar li.active:before,
	#progressbar li.active:after {
		background: #343a40;
	}

	.card {
		background-color: #fff;
		z-index: 0;
	}

	small {
		font-size: 12px !important;
	}

	.a {
		justify-content: space-between !important;
	}

	.border-line {
		border-right: 1px solid rgb(226, 206, 226);
	}

	.card-footer img {
		opacity: 0.3;
	}

	.card-footer h5 {
		font-size: 1.1em;
		color: #8c9eff;
		cursor: pointer;
	}
</style>
